import { gql } from '@apollo/client';

export const GET_SERVICES = gql`
  query Services($input: ServicesInput) {
    services(input: $input) {
      id
      title
    }
  }
`;

export const GET_GOODS = gql`
  query Goods($goodsInput2: GoodsInput) {
    goods(input: $goodsInput2) {
      id
      title
    }
  }
`;

export const GET_TARIFFS = gql`
  query Tariffs($filter: TariffsFilterInput) {
    tariffs(filter: $filter) {
      data {
        id
        title
      }
    }
  }
`;
